module.exports = __webpack_public_path__ + "static/timeline-dots-decoration-09fde9d8a3b010efafd94ba6dfccccd7.svg";